import { IFavoriteProjectResponseModel } from "@lib/types";

export const favoriteProjects = new Array<IFavoriteProjectResponseModel>(
  {
    id: 1001,
  },
  {
    id: 1002,
  },
);
